<template>
  <fragment>
    <div class="grid-bg">
      <div class="container">
        <h1 class="header-level-2 mti_font_element">{{$t('company.header')}}</h1>
      </div>
    </div>

    <div class="resources-landing bright std-cont">
      <div class="container">
        <div class="resources-landing-intro">{{$t("company.intro")}}</div>
        <div class="divider"></div>
        <div class="row reading-content">
          <div class="col-md-9 main-view">
            <img id="company-illustration-1" src="@/assets/images/company-1.jpg?v4.20.3" />
            <h2>{{$t('company.title')}}</h2>
            <p>{{$t('company.story.opening')}}</p>
            <p>{{$t('company.story.content')}}</p>
            <p>{{$t('company.story.ending')}}</p>
            <br />
            <div class="ui-tabs--tab-content-2">
              <table class="std-table highlight-first-col">
                <tbody>
                  <tr>
                    <td>{{$t('company.table-label.name')}}</td>
                    <td>{{$t('company.table-content.name')}}</td>
                  </tr>
                  <tr>
                    <td>{{$t('company.table-label.address')}}</td>
                    <td>
                      <p v-for="line in $t('company.table-content.address').split('\n')" :key="line">{{line}}</p>
                    </td>
                  </tr>
                  <tr>
                    <td>{{$t('company.table-label.date-of-incoporation')}}</td>
                    <td>{{$t('company.table-content.date-of-incoporation')}}</td>
                  </tr>
                  <tr>
                    <td>{{$t('company.table-label.business-outline')}}</td>
                    <td>
                      <ol>
                        <li v-for="line in $t('company.table-content.business-outline').split('\n')" :key="line">{{line}}</li>
                      </ol>
                    </td>
                  </tr>
                  <tr>
                    <td>{{$t('company.table-label.banking-partner')}}</td>
                    <td>{{$t('company.table-content.banking-partner')}}</td>
                  </tr>
                  <tr>
                    <td>{{$t('company.table-label.acn')}}</td>
                    <td>{{$t('company.table-content.acn')}}</td>
                  </tr>
                  <tr>
                    <td>{{$t('company.table-label.abn')}}</td>
                    <td>{{$t('company.table-content.abn')}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="col-md-3 hidden-xs hidden-sm">
            <div class="side-bar-item">
              <div class="related-items">
                <div class="related-items--heading">{{$t('general.suggestion-header')}}</div>
                <ul class="related-items--item-list">
                  <li class="related-items--divider"></li>
                  <li class="related-items--item">
                    <router-link to="/resources/options-glossary">{{$t('general.glossary')}}</router-link>
                  </li>
                  <li class="related-items--divider"></li>
                  <li class="related-items--item">
                    <router-link to="/trade/option-types">{{$t('general.option-types')}}</router-link>
                  </li>
                  <li class="related-items--divider"></li>
                  <li class="related-items--item">
                    <router-link to="/help-and-support">{{$t('general.help-and-support')}}</router-link>
                  </li>
                  <li class="related-items--divider"></li>
                  <li class="related-items--item">
                    <router-link to="#">{{$t('general.try-quick-demo')}}</router-link>
                  </li>
                  <li class="related-items--divider"></li>
                  <li class="related-items--item">
                    <router-link to="#">{{$t('general.sign-up-extra')}}</router-link>
                  </li>
                </ul>
              </div>
            </div>
            <div class="side-bar-item">
              <router-link to="/trade/trading-platforms">
                <img src="@/assets/images/banner-1.png?v4.20.3" />
              </router-link>
            </div>
            <div class="side-bar-item">
              <router-link to="#">
                <img src="@/assets/images/get-a-full-account.png?v4.20.3" />
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </fragment>
</template>

<script>
export default {};
</script>